import * as React from 'react'

const BriefAutofillSparkle = props => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g>
      <g>
        <g>
          <path
            d="M6.816 16.0706C5.50293 16.5346 4.46453 17.5724 4 18.8852C3.53547 17.5724 2.49707 16.5346 1.184 16.0706C2.49761 15.6063 3.53585 14.5683 4 13.2546C4.46415 14.5683 5.50239 15.6063 6.816 16.0706Z"
            fill="#FFBD39"
            stroke="white"
            strokeWidth="0.5"
          />
          <path
            d="M18.6203 7.07038C15.8852 7.80787 13.7378 9.95569 13 12.6906C12.2622 9.95569 10.1148 7.80787 7.37974 7.07038C10.1151 6.33269 12.2626 4.18557 13 1.45012C13.7374 4.18557 15.8849 6.33269 18.6203 7.07038Z"
            fill="#FFBD39"
            stroke="white"
            strokeWidth="0.5"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default BriefAutofillSparkle
